export default {
      id: "editor-eraser-usage",
      viewBox: "0 0 2048 1792",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#editor-eraser",
      toString: function () {
        return this.url;
      }
    }